import { When } from 'react-if';
import { Color } from '../../../common/view/color/color';
import { JsFuncs } from '../../../foundation/js/js.funcs';
import { TripleX } from '../../../foundation/layout/triple-x';
import { UnifiedBoard } from '../board/unified-board';
import { AppStore } from './app.store';
import { SideBar } from './side-bar/side-bar';
import { DesktopToday } from './today/desktop-today';

export function DesktopApp() {
  const appState = AppStore.use();

  return (
    <TripleX.Container style={{ position: 'absolute', inset: 0, justifyItems: 'stretch' }}>
      <TripleX.Side>
        <DesktopToday />
      </TripleX.Side>
      <TripleX.Side>
        <SideBar />
      </TripleX.Side>
      <TripleX.Rest
        style={{
          background: Color.black3,
          color: 'white',
          overflow: 'scroll',
        }}
      >
        <When condition={appState.currentBoardId}>
          <UnifiedBoard boardId={appState.currentBoardId!} />
        </When>
        <When condition={JsFuncs.isNull(appState.currentBoardId)}></When>
      </TripleX.Rest>
    </TripleX.Container>
  );
}
